import React from 'react';
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  LabelList,
  CartesianGrid,
  Label,
  ZAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import Tooltips from 'components/Charts/Tooltips';

interface LabelProps {
  x: number;
  y: number;
  width: number;
  height: number;
  value: string;
}

interface ScaterProps {
  data: any;
  xLabel: string;
  yLabel: string;
}

const Scater = ({ data, xLabel, yLabel }: ScaterProps) => {
  return (
    <ResponsiveContainer width="100%" minHeight="300px">
      <ScatterChart margin={{ top: 40, right: 0, bottom: 20, left: 0 }}>
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis
          domain={[
            (val: any) => {
              return (val - 1).toFixed(2);
            },
            (val: any) => {
              return (val + 1).toFixed(2);
            },
          ]}
          dataKey="x"
          type="number"
          name="Emotions"
        >
          <Label value={xLabel} offset={-10} position="insideBottom" />
        </XAxis>
        <YAxis
          label={{
            value: yLabel,
            angle: -90,
            position: 'insideLeft',
            style: { textAnchor: 'middle' },
          }}
          domain={[
            (val: any) => {
              return (val - 1).toFixed(2);
            },
            (val: any) => {
              return (val + 1).toFixed(2);
            },
          ]}
          tickCount={6}
          dataKey="y"
          type="number"
          name="Relevance"
        />
        <ZAxis
          dataKey="size"
          type="number"
          scale="auto"
          range={[200, 1000]}
          name="Strength"
        />
        <Scatter data={data} fill="#8884d8">
          <LabelList
            dataKey="name"
            position="right"
            content={({ x, y, width, height, value }: LabelProps) => {
              const offset = 1;
              return (
                <>
                  <line
                    x1={x + width / 2}
                    y1={y + height / 2}
                    x2={Number(x) + width}
                    y2={y + height / 2 - 20}
                    style={{ stroke: '#8884d8', strokeWidth: 1 }}
                  />
                  <text
                    x={Number(x) + width + offset}
                    y={y + height / 2 - 20}
                    width={width}
                    height={height}
                  >
                    <tspan dy="0.355rem">{value}</tspan>
                  </text>
                </>
              );
            }}
          />
        </Scatter>
        <Tooltip
          cursor={{ strokeDasharray: '3 3' }}
          content={Tooltips.Default}
        />
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default Scater;
